import { LoanBuilder } from './LoanBuilder';
import { LoanDetails } from './LoanDetails';
import { MonthlyPayments } from './MonthlyPayments';
import { EstimatedClosingCosts } from './EstimatedClosingCosts';
import { PrepaidExpenses } from './PrepaidExpenses';
import { FundsAtClosing } from './FundsAtClosing';

export class ClosingCosts {
  constructor(data = {}) {
    this.loanBuilder = new LoanBuilder(data?.loanBuilder);
    this.loanDetails = new LoanDetails(data?.loanDetails);
    this.estimatedMonthlyPayments = new MonthlyPayments(data?.estimatedMonthlyPayments);
    this.estimatedClosingCosts = new EstimatedClosingCosts(data?.estimatedClosingCosts);
    this.estimatedPrepaidExpenses = new PrepaidExpenses(data?.estimatedPrepaidExpenses);
    this.fundsAtClosing = new FundsAtClosing(data?.fundsAtClosing);
    this.addAppraisalFee = data?.addAppraisalFee;
  }
}
